import { getSessionId } from '@onefootprint/dev-tools';
import type { OnboardingSessionConfig } from '@onefootprint/request-types';

const APPCLIP_URL = 'https://appclip.apple.com/id?p=com.onefootprint.my.Clip' as const;

const createAppclipUrl = ({
  authToken,
  hasAppclipSupport,
  language = 'en',
  onboardingConfig,
  fromContinueOnMobile,
}: {
  authToken?: string;
  hasAppclipSupport: boolean;
  language?: string;
  onboardingConfig?: OnboardingSessionConfig;
  fromContinueOnMobile: boolean;
}) => {
  if (!onboardingConfig?.isAppClipEnabled || !hasAppclipSupport) {
    return {
      isSupported: false,
      url: undefined,
    };
  }

  if (!authToken) {
    return {
      isSupported: true,
      url: undefined,
    };
  }

  const newUrl = new URL(APPCLIP_URL);
  const params = new URLSearchParams(newUrl.search);

  if (language !== 'en') {
    params.append('lng', language);
  }

  const fpSessionId = getSessionId();
  if (fpSessionId) {
    params.append('xfpsessionid', fpSessionId);
  }

  if (fromContinueOnMobile) {
    params.append('userPrefersMobileCapture', 'true');
  }

  params.append('authToken', authToken);

  newUrl.search = params.toString();
  return {
    isSupported: true,
    url: newUrl.toString(),
  };
};

export default createAppclipUrl;
